import { useUserContext } from '@hooks/context/useUserContext';
import { useEffect } from 'react';
import { useKycModals } from '@hooks/modals/useKycModals';
import { EUserStatus } from '@xeppt/xeppt-sdk/types';

export const useGlobalProvider = () => {
    const { userStatus } = useUserContext();
    const { handleOpenHelloKycModal } = useKycModals();

    useEffect(() => {
        if (userStatus === EUserStatus.UNVERIFIED) {
            handleOpenHelloKycModal();
        }
    }, [userStatus]);
};
